import { useQueryClient } from 'react-query';

import showError from 'components/shared/showError';
import { mutations, queryKeys } from 'RestAPIs/rapini';
import { toProtocolRuleRequest } from '../ProtocolRuleForm.utils';

import type { ProtocolRuleResponse } from 'generated/index';
import type { ProtocolRuleFormValues } from '../ProtocolRuleForm.types';

/** Creates the rule, or updates it when one is given; the detail reads the rules from the list */
export const useSaveProtocolRule = (
  protocolId: string,
  rule: ProtocolRuleResponse | undefined,
  onSaved: () => void
) => {
  const queryClient = useQueryClient();
  const options = {
    onSuccess: async () => {
      await queryClient.invalidateQueries(queryKeys.getProtocols());
      onSaved();
    },
    onError: showError
  };
  const { mutate: createRule, isLoading: isCreating } =
    mutations.useCreateProtocolRule(protocolId, options);
  const { mutate: updateRule, isLoading: isUpdating } =
    mutations.useUpdateProtocolRule(protocolId, rule?.id ?? '', options);

  const saveRule = (values: ProtocolRuleFormValues) => {
    const request = toProtocolRuleRequest(values);
    if (rule) {
      updateRule(request);
    } else {
      createRule(request);
    }
  };

  return { saveRule, isSaving: isCreating || isUpdating };
};
